import type { Testimonial } from '../types/content';

export const testimonials: Testimonial[] = [
  {
    title: 'A More Organized Way to Review Hair Restoration Concepts',
    quote:
      'I’ve been looking for a more structured way to organize the educational materials I use for hair restoration. The idea of having anatomy, assessment, and documentation references together in one collection is exactly what I was looking for.',
    name: 'Dr. James Anderson',
    profile: 'Hair Restoration Physician · United States',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/204cc289-9e18-431a-9b9e-bf089c3b6a28.jpg',
  },
  {
    title: 'The Hairline Design Resources Caught My Attention',
    quote:
      'What interests me most about this collection is its focus on hairline design and the educational principles behind aesthetic planning. Having visual references and structured study materials together makes the collection appealing as a professional learning resource.',
    name: 'Dr. Michael Bennett',
    profile: 'Hair Restoration Specialist · United Kingdom',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/aefe1b6f-9af0-48cd-9afe-178b86ae1d2a.jpg',
  },
  {
    title: 'Useful Structure for Professional Study',
    quote:
      'I appreciate educational resources that separate complex topics into clearly defined sections. The combination of follicular anatomy, patient assessment, and donor area references offers a logical structure for organizing my continuing education materials.',
    name: 'Dr. Daniel Rivera',
    profile: 'Medical Professional · Mexico',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/4957171b-4079-4836-970b-9538af276aa0.jpg',
  },
  {
    title: 'Documentation Is an Important Part of the Picture',
    quote:
      'Hair restoration education involves more than studying anatomy and procedures. Documentation and follow-up also matter. I like that this collection includes dedicated resources for organizing those areas.',
    name: 'Dr. Christopher Hayes',
    profile: 'Hair Restoration Professional · Canada',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/9003ffb1-fdca-414f-893c-c3813228f4fb.jpg',
  },
  {
    title: 'A Clearly Structured Educational Collection',
    quote:
      'The six-volume format makes the concept easy to understand. Rather than purchasing a general reference with an unclear scope, you can see the different educational topics covered and decide whether they fit your learning needs.',
    name: 'Dr. Ryan Mitchell',
    profile: 'Healthcare Professional · Australia',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/b296c58e-37b6-4044-803d-0bae8d6e3846.jpg',
  },
  {
    title: 'The Bonuses Complete the Collection',
    quote:
      'The patient assessment toolkit and the follow-up documentation templates were what convinced me. Having worksheets I can adapt to my own clinic, alongside the six volumes, gives the collection real practical value for day-to-day study.',
    name: 'Dr. Elena García',
    profile: 'Dermatologist · Spain',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c381f309-e6c2-4907-9205-6a87ab002229.jpg',
  },
];
